import React from 'react';
import styled from 'styled-components';
import { SmallSectionHeader, Captions } from 'components/Typography';

export const StyledtBlocWrapper = styled(({ height, ...otherProps }) => (
  <div {...otherProps} />
))`
  height: ${(props) => props.height};
`;

export const StyledtBlocSearch = styled(({ ...otherProps }) => (
  <div {...otherProps} />
))`
  margin-bottom: 10px;
`;

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;

export const StyledCaption = styled(Captions)`
  && {
    color: #9797af;
    font-size: 13px !important;
    margin: 1px !important;
    line-height: 16px;
    height: 16px;
    font-family: Roboto;
    font-weight: 500;
    letter-spacing: 0;
    align-items: center;
  }
`;
